export default "__VITE_ASSET__66476f5c__"